import { useMemo } from 'react'
import cx from 'classnames'
import styles from './QuestionContent.module.css'
import { Icon } from '@/components/Icon'
import { RawButton } from '@/components/Button'
import { markdownToHtml } from '@/utils/markdown-util'

export interface QuestionTitleProps {
  title: string
  compact?: boolean
  onToggleInfo?(): unknown
}

export function QuestionTitle({
  title,
  compact,
  onToggleInfo,
}: QuestionTitleProps) {
  return (
    <h4 className={styles.title}>
      <span className={cx(compact && styles.compactTitle)}>{title}</span>
      {onToggleInfo && (
        <RawButton className={styles.titleInfoToggle} onPress={onToggleInfo}>
          <span className={styles.titleInfoIcon}>
            <Icon auto name="info" />
          </span>
        </RawButton>
      )}
    </h4>
  )
}

export interface QuestionDescriptionProps {
  description: string
  hidden?: boolean
}

export function QuestionDescription({
  description,
  hidden,
}: QuestionDescriptionProps) {
  const html = useMemo(() => markdownToHtml(description), [description])
  return hidden ? null : (
    <div
      className={styles.description}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}
